import { render, staticRenderFns } from "./TransferJobModal.vue?vue&type=template&id=03d8f258&"
import script from "./TransferJobModal.vue?vue&type=script&lang=ts&"
export * from "./TransferJobModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports